import React from 'react';
import CandidateReview  from './CandidateReview';

/**
* @desc candidate column for review page based on status
* @version 
* @author Lakshmikanth 
*/

/**
* @desc setting drag and drop list based on status
* @param props
* @return DOM element
*/
const CandidateColumns = (props) => {
  const listTitleClass = "pool-list-header " + props.status.toLowerCase() + "-header";
  return (      
    <div className="pool-list"> 
      <div className={listTitleClass}>
        {(props.status === "PENDING") ? "UNSORTED" : props.status}
      </div>
      { props.pool.map((candidate, index) => (
        <div className="review-pool-card" key={index} >
          <CandidateReview 
            handleCandidateSelect={props.handleCandidateSelect} 
            activeCandidateId={props.activeCandidateId} 
            poolStatus={props.pool[candidate.id]} 
            key={index} 
            {...candidate} />
        </div>
        ))
      }
    </div>
  );
}

export default CandidateColumns;


// WEBPACK FOOTER //
// ./src/components/Client/CandidateReview/CandidateColumns.js